import React from "react";
import Button from "@mui/material/Button";
import { ContentCopy } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import useCopyClipboard from "../../hooks/useCopyClipboard";
import { FormattedMessage, useIntl } from "react-intl";
import { OverridableStringUnion } from "@mui/types";
import { SvgIconPropsSizeOverrides } from "@mui/material/SvgIcon/SvgIcon";

interface CopyClipboardProp {
  text: string;
  toCopy?: string;
  onlyIcon?: boolean;
  style?: React.CSSProperties;
  className?: string | undefined;
  fontSize?: OverridableStringUnion<
    "inherit" | "large" | "medium" | "small",
    SvgIconPropsSizeOverrides
  >;
}
export const CopyClipboard: React.FC<CopyClipboardProp> = ({
  text,
  toCopy,
  onlyIcon = false,
  style,
  className,
  fontSize,
}) => {
  const [isCopied, setCopied] = useCopyClipboard();
  const { formatMessage } = useIntl();
  return (
    <Tooltip
      title={
        isCopied
          ? formatMessage({ defaultMessage: "Copied" })
          : formatMessage({ defaultMessage: "Click to copy to Clipboard." })
      }
      arrow
      placement="top"
    >
      <Button
        className={className}
        style={style}
        onClick={() => setCopied(toCopy ? toCopy : text)}
      >
        {isCopied ? (
          <span style={{ marginLeft: "4px" }}>
            <FormattedMessage defaultMessage="Copied" />
          </span>
        ) : (
          <>
            {onlyIcon ? null : text}
            <ContentCopy fontSize={fontSize} />
          </>
        )}
      </Button>
    </Tooltip>
  );
};
